import React, { Component } from "react";
import { withStyles, Grid, Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Redirect, Route, Switch } from "react-router-dom";

import { connect } from "react-redux";

import NavBar from "./Navbar/NavBar";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";
import { topRoutes, bottomRoutes, tenantRoutes } from "./Routes/ProjectRoutes";
import { TENANT_ID } from "../../config/config";
import clsx from "clsx";
import Preloader from "../../static/preloader.gif";
import {
  verifyRouteAccess,
  verifyRouteAccess2,
} from "../../helpers/accessControlHelper";
import ErrorPage from "../ErrorPage/ErrorPage";
import ProtectedRoute from "./ProtectedRoute";
import TabSwitcher from "../../components/TabSwitcher/TabSwitcher";

// Helper function to find the first accessible route
const findFirstAccessibleRoute = (routes, permissions) => {
  return routes.find((route) => verifyRouteAccess2(permissions, route))?.to;
};

class ProjectsLayout extends Component {
  state = {
    status: "",
    statusMessage: "",
    isLoadingPermissions: true,
  };

  componentDidMount() {
    if (this.props.permissions?.length) {
      this.setState({ isLoadingPermissions: false });
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.permissions?.length && this.props.permissions?.length) {
      this.setState({ isLoadingPermissions: false });
    }
  }

  render() {
    const { classes, location, agent, permissions } = this.props;
    const { isLoadingPermissions } = this.state;
    const pathname = location.pathname;
    const routes = TENANT_ID ? tenantRoutes : topRoutes;

    if (isLoadingPermissions) {
      return (
        <div className={classes.root}>
          <div className={classes.routeContainer}>
            <img
              src={Preloader}
              alt="Loading..."
              className={classes.preloader}
            />
          </div>
        </div>
      );
    }

    return (
      <div id="projects-layout" className={classes.root}>
        <NavBar />
        <TabSwitcher />
        <ErrorBoundary>
          <div id="route-container" className={classes.routeContainer}>
            <Switch>
              {bottomRoutes.map((route) => {
                return (
                  <Route
                    exact
                    key={route.name}
                    path={route.to}
                    component={route.component}
                  />
                );
              })}
              <Route
                exact
                path="/"
                render={() => {
                  // Check if user has access to dashboard
                  const hasDashboardAccess = verifyRouteAccess2(permissions, {
                    to: "/",
                  });
                  if (hasDashboardAccess) {
                    const DashboardComponent = routes.find(
                      (r) => r.to === "/"
                    )?.component;
                    return <DashboardComponent />;
                  }
                  // Find first accessible route
                  const firstAccessibleRoute = findFirstAccessibleRoute(
                    routes,
                    permissions
                  );
                  return firstAccessibleRoute ? (
                    <Redirect to={firstAccessibleRoute} />
                  ) : (
                    <Redirect to="/error" />
                  );
                }}
              />
              {routes
                .filter((route) => route.to !== "/")
                .map((route, index) => {
                  return (
                    <ProtectedRoute
                      key={route.name}
                      path={route.to}
                      component={route.component}
                      hasAccess={verifyRouteAccess2(permissions, route)}
                    />
                  );
                })}

              <Route component={() => <Redirect to="/error" />} />
            </Switch>
          </div>
        </ErrorBoundary>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    width: "100vw",
    height: "100vh",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      overflowY: "auto",
      position: "relative",
    },
  },
  routeContainer: {
    width: "calc(100% - 70px)",
    height: "100vh",
    transition: "1s",
    overflow: "hidden",
    marginLeft: 70,
    // background: "green",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "calc(100vh - 50px)",
      // height: "100vh",
      marginLeft: 0,
    },
  },
  fullHeight: {
    [theme.breakpoints.down("sm")]: {
      height: "100vh",
    },
  },
  preloader: {
    height: 150,
  },
});

const connectedProjectslayout = connect((state) => ({
  agent: state.login.user,
  permissions: state.login.permissions,
}))(ProjectsLayout);

export default withStyles(styles)(connectedProjectslayout);
